import { io, Socket } from "socket.io-client";
import { API_BASE } from "../api/client";
import { getToken } from "../auth/auth";

let socket: Socket | null = null;

export function getRealtimeSocket(): Socket {
  if (socket) return socket;

  socket = io(`${API_BASE}/realtime`, {
    autoConnect: false,
    transports: ["websocket", "polling"],
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
  });

  return socket;
}

function currentSocketToken(s: Socket): string | undefined {
  return (s.auth as { token?: string } | undefined)?.token;
}

export function connectRealtime(): Socket {
  const s = getRealtimeSocket();
  const token = getToken();
  if (!token) {
    if (s.connected) s.disconnect();
    return s;
  }

  // If the token rotated (e.g. after a 401 refresh) while connected, the live
  // socket is still authenticated with the stale token — force a reconnect so
  // the fresh credential is sent on the handshake.
  if (s.connected && currentSocketToken(s) !== token) {
    s.disconnect();
  }

  s.auth = { token };
  if (!s.connected) s.connect();
  return s;
}

// Called after the access token is refreshed. No-op if realtime was never
// started; otherwise re-handshakes with the fresh token.
export function reauthRealtime(): void {
  if (!socket) return;
  connectRealtime();
}

export function disconnectRealtime(): void {
  const s = getRealtimeSocket();
  if (s.connected) s.disconnect();
}

export function isRealtimeConnected(): boolean {
  const s = getRealtimeSocket();
  return s.connected;
}

